import type { InvoiceDetailsDraftPayment } from "@/queries/invoices/get";

import { PaymentCard } from "./payment-card";

type Props = {
  payments: InvoiceDetailsDraftPayment[];
};

export const PaymentsList = ({ payments }: Props) => {
  return (
    <div className="flex flex-col gap-2">
      {payments.length > 0 && (
        <div className="flex flex-col gap-2">
          {payments.map((payment) => (
            <PaymentCard key={payment.draftPaymentId} {...payment} />
          ))}
        </div>
      )}
    </div>
  );
};
